const win: any = window;
/**
 * 通知客户端修改标题
 * @param title 标题内容 
 */
export const setPageTitle = (title: string) => {
    document.title = title;

    if (/hexin/gi.test(navigator.userAgent)) {
        if (navigator.userAgent.toLowerCase().indexOf('android') > 0) {
            win.callNativeHandler('changeWebViewTitle', {
                title,
                url: '',
            },
                function () {
                    //
                }
            );
        } else {
            win.callNativeHandler('updateTitleAutomatically');
        }
    }
};
